module.exports = __webpack_public_path__ + "darkimg-project-noaction.a029645405a3407156511359dc631fe0.hashedasset.svg";